import { navigations } from "../../app/navigations";
import * as types from '../types';

const initialState = [...navigations];

const NavigationReducer = function(state = initialState, action) {
  switch (action.type) {
    case types.SET_USER_NAVIGATION: {
      return [...action.payload];
    }
    default: {
      return [...state];
    }
  }
};

export default NavigationReducer;
